// extracted by mini-css-extract-plugin
module.exports = {"form":"MailingListForm_form__3dmxW","submitNote":"MailingListForm_submitNote__Hdwke"};